import PropTypes from 'prop-types';
import identity from 'lodash/identity';
import { translate } from '../../helpers/i18n';

/**
 * @typedef {object} LocaleProps
 * @property {(stringToFormat: string, options?: Record<string, any>) => string} [formatter] Formatter function. If it has a `supportsOptions` property set to true, it will receive options as second parameter.
 * @property {Record<string, any>} [options] Replacement values to be used in the translation
 * @property {string|string[]} path
 */

/** @type {React.FC<LocaleProps>} */
const Locale = ({ formatter = identity, path, options = {} } = {}) => {
    if (!path) {
        return null;
    }

    const translatedText = translate(
        path,
        Object.entries(options).reduce(
            (acc, [key, value]) => (
                (acc[key] = typeof value === 'string' ? translate(value, options) : value), acc
            ),
            {}
        )
    );

    if (!translatedText) {
        return null;
    }

    // Pass options to BBCode to support custom click handlers
    if (formatter.supportsOptions) {
        return formatter(translatedText, options);
    }

    return formatter(translatedText);
};

Locale.propTypes = {
    formatter: PropTypes.func,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
    options: PropTypes.object,
};

export default Locale;
